import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import * as i0 from "@angular/core";
import * as i1 from "../../../../@fuse/services/translation-loader.service";
import * as i2 from "@ngx-translate/core";
var AddressValidationService = /** @class */ (function () {
    function AddressValidationService(fuseTranslationLoaderService, translateService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    AddressValidationService.prototype.validateAddress = function (address) {
        var errors = [];
        var warnings = [];
        if (address) {
            if (!address.postalCode) {
                warnings.push(this.translateService.instant('ADDRESS_VALIDATION.POSTAL_CODE'));
            }
            if (!address.state) {
                errors.push(this.translateService.instant('ADDRESS_VALIDATION.STATE'));
            }
            if (!address.city) {
                errors.push(this.translateService.instant('ADDRESS_VALIDATION.CITY'));
            }
            if (!address.streetName) {
                warnings.push(this.translateService.instant('ADDRESS_VALIDATION.STREET'));
            }
            if (!address.neighborhood) {
                warnings.push(this.translateService.instant('ADDRESS_VALIDATION.NEIGHBORHOOD'));
            }
            if (!address.number) {
                warnings.push(this.translateService.instant('ADDRESS_VALIDATION.NUMBER'));
            }
        }
        return {
            valid: !errors.length,
            errors: errors.length ? errors : null,
            warnings: warnings.length ? warnings : null
        };
    };
    AddressValidationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AddressValidationService_Factory() { return new AddressValidationService(i0.ɵɵinject(i1.FuseTranslationLoaderService), i0.ɵɵinject(i2.TranslateService)); }, token: AddressValidationService, providedIn: "root" });
    return AddressValidationService;
}());
export { AddressValidationService };
